<template>
  <div id="sort-order-dialog">
    <div class="content">
      <div class="body px-3 pt-3 pb-2">
        <p class="title mb-3">並び順</p>

        <hr class="partition px-1 my-2" />

        <b-form-radio-group name="sort-key" v-model="formKey" stacked>
          <b-form-radio class="sort-order-radio" value="creation">トークの作成順</b-form-radio>
          <b-form-radio class="sort-order-radio" value="updated">メッセージの受取順</b-form-radio>
        </b-form-radio-group>

        <hr class="partition px-1 my-2" />

        <b-form-radio-group name="sort-direction" v-model="formDirection" stacked>
          <b-form-radio class="sort-order-radio" value="asc">昇順</b-form-radio>
          <b-form-radio class="sort-order-radio" value="desc">降順</b-form-radio>
        </b-form-radio-group>

        <hr class="partition px-1 my-2" />

        <b-form-checkbox v-model="formFavoritePriority" class="favorite-checkbox">
          お気に入りを優先
        </b-form-checkbox>
      </div>

      <hr class="partition m-0" />

      <div class="d-flex p-2">
        <cancel label="キャンセル" v-on:cancel="close" />
        <confirm label="実行" v-on:confirm="submit" class="ml-2" />
      </div>
    </div>

    <div class="overlay" @click="close" />
  </div>
</template>

<style lang="scss" src="./sort-order-dialog.scss" scoped />

<script lang="ts">
import { defineComponent, onMounted, ref, type PropType } from "vue";
import Confirm from "./../button/Confirm.vue";
import Cancel from "./../button/Cancel.vue";
import {
  DEFAULT_SORT_CONFIG,
  type SortConfig,
  type SortDirection,
  type SortKey,
} from "./sort-talks";

export default defineComponent({
  name: "sort-order-dialog",
  components: { Confirm, Cancel },
  props: {
    value: {
      type: Object as PropType<SortConfig>,
      default: () => ({ ...DEFAULT_SORT_CONFIG }),
    },
  },
  setup(props, { emit }) {
    const formKey = ref<SortKey>(DEFAULT_SORT_CONFIG.key);
    const formDirection = ref<SortDirection>(DEFAULT_SORT_CONFIG.direction);
    const formFavoritePriority = ref(DEFAULT_SORT_CONFIG.favoritePriority);

    // ダイアログは開くたびにマウントされるため、初期値は props から一度だけ取り込む
    onMounted(() => {
      formKey.value = props.value.key;
      formDirection.value = props.value.direction;
      formFavoritePriority.value = props.value.favoritePriority;
    });

    const close = (): void => {
      emit("close");
    };

    const submit = (): void => {
      const config: SortConfig = {
        key: formKey.value,
        direction: formDirection.value,
        favoritePriority: formFavoritePriority.value,
      };
      emit("change-value", config);
      close();
    };

    return { formKey, formDirection, formFavoritePriority, close, submit };
  },
});
</script>
